// Contenedor de diálogos unificado: cabecera con degradado de marca,
// pantalla completa en móvil y acciones fijas abajo.
import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const HEADER_COLORS = {
  primary: "#F59E0B",
  info: "#1A73E8",
  success: "#43A047",
  error: "#E53935",
  dark: "#22336B",
};

export default function ModalShell({
  open,
  onClose,
  title,
  subtitle,
  icon: Icon,
  color = "primary",
  maxWidth = "sm",
  actions,
  children,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth={maxWidth}
      TransitionComponent={fullScreen ? Transition : undefined}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : 3,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: { xs: 2.5, sm: 3 },
          py: 2.25,
          backgroundColor: HEADER_COLORS[color] || HEADER_COLORS.primary,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
          {Icon && (
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "12px",
                bgcolor: "rgba(255,255,255,0.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon sx={{ color: "#fff", fontSize: 22 }} />
            </Box>
          )}
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" color="#fff" fontWeight={700} noWrap lineHeight={1.25}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="rgba(255,255,255,0.85)" noWrap display="block">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
        <IconButton onClick={onClose} size="small" sx={{ color: "#fff", flexShrink: 0 }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ p: { xs: 2.5, sm: 3 } }}>{children}</DialogContent>

      {actions && (
        <DialogActions
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: 2,
            borderTop: "1px solid",
            borderColor: "grey.200",
            gap: 1,
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
}

ModalShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  icon: PropTypes.elementType,
  color: PropTypes.oneOf(["primary", "info", "success", "error", "dark"]),
  maxWidth: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
};
